import { change_Theme } from "../../actions/actionConstants";
import { theme_light } from "../../../commonConstants";

const localStorageKey = "react-ecg-report redux.state.app.settings.theme";
const defaultTheme = theme_light;

const load = () => {
    try {
        const theme = localStorage.getItem(localStorageKey);
        return theme || defaultTheme;
    } catch (err) {
        return defaultTheme;
    }
};

const save = theme => {
    localStorage.setItem(localStorageKey, theme);
};

const updateTheme = (state, action) => {
    if (state === undefined) {
        return load();
    }

    switch (action.type) {
        case change_Theme:
            save(action.payload);
            return action.payload;
        default:
            return state.app.settings.theme;
    }
};

export default updateTheme;
